import React from "react";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import './CustomCalendar.css';

export default function CustomCalendar({ value, onChange, tileDisabled, tileClassName }) {
    return (
        <Calendar
            value={value}
            onChange={onChange}
            tileDisabled={tileDisabled}
            tileClassName={tileClassName}
        />
    );
}

